<template>
  <v-menu v-if="$can('INTERNAL_SUPPORT')" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        :color="statusColor(item.onboarding_status)"
        x-small
      >
        {{ text }}
        <span v-if="item.onboarding_user_id"> 
          |<v-icon x-small>mdi-account</v-icon>
          {{ onboardingSpecialist }}
        </span>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(status, index) in $in('ConstOnboardingStatuses')"
        :key="index"
        @click="replace({
          onboarding_status: status.value
        })"
      >
        <v-list-item-title>{{ $constText('ConstOnboardingStatuses', status.value) }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  REPLACE_COMPANIES,
} from "@/store/companies/actions";

export default {
  name: "OnboardingStatusChip",
  props: {
    item: {
      required: true,
    }
  },
  methods: {
    statusColor(value) {
      const statusColors = {
        CREATION: 'info',
        IN_PROGRESS: 'warning',
        CONNECTIONS_STARTED: 'accent',
        COMPLETED: 'success',
        BLOCKED: 'error',
        ARCHIVED: 'warning',
        TO_BE_REMOVED: 'error',
      };

      return statusColors[this.$const('ConstOnboardingStatuses', value)] || null;
    },
    replace(params) {
      this.$store.dispatch(REPLACE_COMPANIES, {
        id: this.item.id,
        params: params,
      }).then(() => { this.$emit('updated')});
    }
  },
  computed: {
    text() {
      return this.$constText('ConstOnboardingStatuses', this.item.onboarding_status);
    },
    onboardingSpecialist() {
      if (!this.item.onboarding_user_id) {
        return '';
      }

      return this.item.onboarding_user.name.split(' ')[0];
    }
  }
}
</script>